export const grants = [
  'create_client',
  'edit_client',
  'delete_client',
  'read_clients',
  'create_item',
  'edit_item',
  'delete_item',
  'read_items',
  'create_truck',
  'edit_truck',
  'delete_truck',
  'read_trucks',
  'create_trailer',
  'edit_trailer',
  'delete_trailer',
  'read_trailers',
  'create_driver',
  'edit_driver',
  'delete_driver',
  'read_drivers',
  'create_document_type',
  'edit_document_type',
  'delete_document_type',
  'read_document_types',
  'create_unit',
  'edit_unit',
  'delete_unit',
  'read_units',
  'create_tasky_type',
  'edit_tasky_type',
  'delete_tasky_type',
  'read_tasky_types',
  'create_warehouse',
  'edit_warehouse',
  'delete_warehouse',
  'read_warehouses',
  'create_warehouse_task_workflow',
  'edit_warehouse_task_workflow',
  'delete_warehouse_task_workflow',
  'read_warehouse_task_workflows',
  'create_warehouse_task_file',
  'edit_warehouse_task_file',
  'delete_warehouse_task_file',
  'read_warehouse_task_files',
  'create_warehouse_task',
  'edit_warehouse_task',
  'delete_warehouse_task',
  'read_warehouse_tasks',
  'create_warehouse_task_movement',
  'edit_warehouse_task_movement',
  'delete_warehouse_task_movement',
  'read_warehouse_task_movements',
  'create_task_type',
  'edit_task_type',
  'delete_task_type',
  'read_task_types',
  'create_client_warehouse',
  'edit_client_warehouse',
  'delete_client_warehouse',
  'read_client_warehouses',
  'create_warehouse_price',
  'edit_warehouse_price',
  'delete_warehouse_price',
  'read_warehouse_prices',
  'create_movement_price',
  'edit_movement_price',
  'delete_movement_price',
  'read_movement_prices',
  'read_stock',
  'edit_stock',
  'read_charge_report',
  'read_biling_report',
  'excel_export_billing_report',
  'read_reports',
  'create_report',
  'edit_report',
  'delete_report',
  'read_workflow_notifications',
  'create_workflow_notifications',
  'edit_workflow_notifications',
  'delete_workflow_notifications',
  'lock_stock_data_change',
  'storage_clients',
  'storage_warehouse_task_files',
]

export default grants
